import { t } from "i18next";

const LegendInfo = () => {
    const containerStyle = {
        // maxWidth: '600px',
        margin: '20px auto',
        padding: '15px 20px',
        // backgroundColor: '#f9f9f9',
        // borderLeft: '4px solid #007BFF',
        // borderRadius: '8px',
        fontFamily: 'Poppins',
        color: '#333',
        fontSize: '12px'
    };

    const titleStyle = {
        marginBottom: '10px',
        fontSize: '20px',
        fontWeight: 'bold',
    };

    const listStyle = {
        listStyleType: 'none',
        paddingLeft: '0',
        lineHeight: '1.6',
    };

    const nestedListStyle = {
        listStyleType: 'none',
        paddingLeft: '20px',
    };

    const bold = { fontWeight: 'bold' };

    return (
        <div style={containerStyle}>
            {/* <div style={titleStyle}>Legends</div> */}
            <ul style={listStyle}>
                <li>
                    <span style={bold}>{t('Startingcharacter')}</span>
                    <ul style={nestedListStyle}>
                        <li><span style={bold}>G</span> – General</li>
                        <li><span style={bold}>L</span> – Ladies</li>
                    </ul>
                </li>
                <li>
                    <span style={bold}>{t('Endcharacter')}</span>
                    <ul style={nestedListStyle}>
                        <li><span style={bold}>H</span> – Home University</li>
                        <li><span style={bold}>O</span> – Other than Home University</li>
                        <li><span style={bold}>S</span> – State Level</li>
                        <li><span style={bold}>AI</span> – All India Seat</li>
                    </ul>
                </li>
                <li>{t('Example')} </li></ul>
            <img
                src={"/LegendImg.PNG"}  // Replace with your SVG path
                alt="SVG Image"
                style={{
                    width: '100%',
                    height: 'auto',
                }}
            />
        </div>
    );
};

export default LegendInfo;
